import { combineReducers } from "redux";
import stepper from './stepper';


export default combineReducers({
    stepper
})